import { get } from "lodash";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import Page from "../components/pages/page/Page";
import { IFormType, IOperationData, MatchExpr } from "../constants/types";

import { submit_phase_index } from "../constants/constants";

import './Form.scss';
import SubmitPage from "../components/pages/submitPage/SubmitPage";

interface Props extends WithTranslation {
    form: IFormType
};

interface State {
    pageIndex: number,
    path: number[],
    data: {
        [id: string]: IOperationData
    }
};

class Form extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        const startPage = props.form.pages[props.form.startIndex];

        this.state = {
            pageIndex: props.form.startIndex,
            path: [],
            data: {
                [startPage.id]: {
                    OK: false,
                    discarded: false
                }
            }
        };
    }

    getNextPageIndex(match: MatchExpr, data: IOperationData) {
        let value = get(data, match.valueSource);

        return match.cases[value] || match.cases.default;
    }

    next = () => {
        const { pageIndex, data } = this.state;
        const page = this.props.form.pages[pageIndex];
        const pageData = data[page.id];

        const nextIndex = this.getNextPageIndex(page.operation.next, pageData);

        if (nextIndex === submit_phase_index) {
            this.setState(({ path }) => ({
                pageIndex: nextIndex,
                path: [...path, pageIndex],
            }));
        }
        else {

            const nextPage = this.props.form.pages[nextIndex];

            this.setState(({ data, path }) => ({
                pageIndex: nextIndex,
                path: [...path, pageIndex],
                data: {
                    ...data,
                    [nextPage.id]: {
                        ...data[nextPage.id],
                        discarded: false
                    }
                }
            }));
        }
    }

    onChange = (changes: IOperationData) => {
        const { pageIndex } = this.state;
        const page = this.props.form.pages[pageIndex];
        this.setState(({ data }) => ({
            data: {
                ...data,
                [page.id]: {
                    ...changes,
                    discarded: false
                }
            }
        }), () => {
            if (this.shouldAutoNext(changes)) this.next();
        });
    }

    shouldAutoNext = (changes: IOperationData) => {
        const { pageIndex } = this.state;
        const page = this.props.form.pages[pageIndex];
        const currentAutoNext = page?.operation?.next?.autoNext;
        if (currentAutoNext?.allAutoNext) return true;
        return changes.OK && changes.value != undefined && currentAutoNext?.shouldAutoNext?.includes(changes.value);
    }

    onChangeWithIndex = (pageIndex: number, changes: IOperationData) => {
        const page = this.props.form.pages[pageIndex];

        this.setState(({ data }) => ({
            data: {
                ...data,
                [page.id]: {
                    ...changes,
                    discarded: false
                }
            }
        }));
    }

    undo = () => {
        const { pageIndex } = this.state;

        if (pageIndex === submit_phase_index) {
            const path = [...this.state.path];
            const nextIndex = path.pop();

            if (nextIndex !== undefined) {
                this.setState(() => ({
                    pageIndex: nextIndex,
                    path: path
                }));
            }
        }
        else {
            const page = this.props.form.pages[pageIndex];

            const path = [...this.state.path];
            const nextIndex = path.pop();

            if (nextIndex !== undefined) {
                this.setState(({ data }) => ({
                    pageIndex: nextIndex,
                    path: path,
                    data: {
                        ...data,
                        [page.id]: {
                            ...data[page.id],
                            discarded: true
                        }
                    }
                }));
            }
        }
    }

    undoTo = (index: number) => {
        const { pageIndex } = this.state;
        let { data, path } = this.state;

        let currIndex = pageIndex;

        while (currIndex != index) {
            currIndex = path.pop() ?? -1;
            const page = this.props.form.pages[currIndex];
            data[page.id].discarded = true;
        }

        this.setState({ pageIndex: index, path: path, data: data });
    }

    render() {
        const { pageIndex, data, path } = this.state;

        if (pageIndex === submit_phase_index) {
            return <div className="render-form">
                <SubmitPage pages={this.props.form.pages} path={path} data={data} onUndo={this.undo} undoTo={this.undoTo} onChange={this.onChangeWithIndex} />
            </div>;
        }
        else {
            const page = this.props.form.pages[pageIndex];
            const pageData = data[page.id];

            return <div className="render-form">
                <Page pageType={page} data={pageData} onUndo={path.length > 0 ? this.undo : undefined} onChange={this.onChange} onNext={this.next} />
            </div>;
        }
    }
};

export default withTranslation()(Form);